import { render, staticRenderFns } from "./Google2saLoginModule.vue?vue&type=template&id=231e4824&"
import script from "./Google2saLoginModule.vue?vue&type=script&lang=js&"
export * from "./Google2saLoginModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports